/// <amd-module name="Test/TestPlansHubRefresh/Pivots/ChartsPivot/Component/ChartsTabConnectedComponent" />
import * as React from "react";
import { connect } from "react-redux";
import { TestHubRefreshLocalContext } from "Test/TestPlansHubRefresh/TestHub/Utils/TestPlansHubRefreshLocalContextProvider";
import { ITestHubRefreshLocalContext, ITestHubRefreshAwareState } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshContracts";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentContext, IVssComponentProperties, VssComponent, IVssLayoutManager } from "VSS/Platform/Layout";
import { ILegacyComponentProperties, LegacyComponent } from "VSS/Legacy/Legacy";
import { ITfsPageService } from "Tfs/Platform/Page"
import { IVssPageService } from "VSS/Platform/Page"

export interface IChartsTabComponentProps extends IVssComponentProperties {
    planId: number;
    suiteId: number;
    suiteName: string;

    // The react context object. TestPlansHubRefreshConnectedView is the provider of this data.
    testhubRefreshContext?: ITestHubRefreshLocalContext;
}

export class ChartsTabContentComponent extends VssComponent<IChartsTabComponentProps, IVssComponentContext> {
    private _context: IVssPageContext;

    constructor(props: IChartsTabComponentProps, context: IVssComponentContext) {
        super(props, context);
        this._context = context.pageContext;
    }

    public render(): JSX.Element {
        const tfsPageService = this._context.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();

        if (!tfsPageData || !tfsPageData.project) {
            throw new Error("Project missing");
        }

        const pageService = this._context.getService<IVssPageService>("IVssPageService");
        const pageData = pageService.getData();
        let userId = "";
        let userName = "";
        if (pageData && pageData.user) {
            userId = pageData.user.id;
            userName = pageData.user.displayName;
        }

        const chartsProps = {
            suite: { name: this.props.suiteName, id: this.props.suiteId },
            plan: { id: this.props.planId },
            tfsContext: {
                contextData: {
                    project: {
                        id: tfsPageData.project.id,
                        name: tfsPageData.project.name
                    },
                    user: {
                        id: userId,
                        name: userName
                    }
                },
                navigation: {
                    projectId: tfsPageData.project.id
                }
            }
        }
        // calling layoutManager.renderCallout is enough to render the complete charts view. 
        const layoutManager = this._context.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutManager.renderCallout((onDismiss: any) => {
            const properties: ILegacyComponentProperties = {
                modules: ["TestManagement/Scripts/Shared/ChartsProxy"],
                wrappedType: "charts-proxy",
                wrappedProps: chartsProps
            };
            return React.createElement(LegacyComponent, properties);
        });

        // div with class name "hub-refresh-charts-view" act as the parent div for the charts view rendered above using layoutManager  
        return (
            <div className="hub-refresh-charts-view"></div>
        )
    }

    // Using componentDidMount instead of compDidUpdate because charts tab is empty, and it doesn't get updated
    public componentDidMount() {
        this._markTTIPerf();
    }

    private _markTTIPerf() {
        if (this.props.testhubRefreshContext && this.props.testhubRefreshContext.isPageLoad()) {
            // publish tti telemetry when we take up work for charts pivot
            this.props.testhubRefreshContext.setPageLoad(false);
        }
    }
}

function mapStateToProps(state: ITestHubRefreshAwareState): Partial<IChartsTabComponentProps> {
    return {
        planId: state.testHubRefreshState.testPlanId,
        suiteId: state.testHubRefreshState.selectedSuiteId,
        suiteName: state.testHubRefreshState.selectedSuiteName
    };
}

/**
 * ChartsTabFunctionalComponent: This functional component is just a dumb wrapper over ChartsTabContentComponent.
 * We use this because React.useContext can only be invoked in function components. We get the context here and then pass is as props to the class component.
 */
export function ChartsTabFunctionalComponent(props: IChartsTabComponentProps): JSX.Element {
    const testhubRefreshLocalContext = React.useContext(TestHubRefreshLocalContext);

    return <ChartsTabContentComponent {...props} testhubRefreshContext={testhubRefreshLocalContext} />;
}

export const ChartsTabConectedComponent = connect(
    mapStateToProps,
    null
)(ChartsTabFunctionalComponent);

VssComponent.register("chartsPivot", ChartsTabConectedComponent as ((props: IChartsTabComponentProps) => JSX.Element));
